import React, {Component, Fragment} from "react";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import OnSamsatHeaderInputModifying from "./onSamsatHeaderInputModifying";
import OnSamsatDetailInputModifying from "./onSamsatDetailInputModifying";
import Api from "../../../../Services/Api";
import * as R from "ramda";
import {contructQueryParam, fetchDataAsync} from "../../../../Services/Utils";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import {formGroupOnSamsatAcceptance} from "./config";
import {getData, saveReceivingSamsat} from "./util";
import {connect} from "react-redux";
import {HttpStatus} from "../../../common/Constants";

class OnSamsatAcceptanceModifying extends Component {
    listTabPanel = ["STNK", "Lembar Pajak", "Plat Kendaraan", "BPKB"];
    listTabValue = ["stnk", "taxSheets", "platNumber", "bpkb"];

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            activeTab: "stnk",
            dataDetail: {},
        }
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        await this.fetchData();
        this.handleTriggerLoading();
    }

    handleTabChange = (tab) => {
        this.setState((prevState) => ({
            ...prevState,
            activeTab: tab,
        }))
    }

    handleSubmit = async (payload) => {
        this.handleTriggerLoading();
        console.log("payload", payload);
        let res = await saveReceivingSamsat(this.state.activeTab, payload, this.props.setError);
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.props.triggerRefetch();
            await this.fetchData();
        }
        this.handleTriggerLoading();
    }

    handlePrint = () => {

    }

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    fetchData = async () => {
        let response = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION").findDetailReceivingSamsat,
            menuName: "Process Samsat",
            setError: this.props.setError,
            args: contructQueryParam({
                kodeCabang: this.props.selectedCabang?.value,
                processSamsatId: this.props.selectedData.processSamsatId,
            })
        });

        if (response.ok && response.data.status === HttpStatus.SUCCESS) {
            let kodeCabang = this.props.selectedCabang?.value;
            let processSamsatId = this.props.selectedData.processSamsatId;
            await this.setState((prevValue) => ({
                ...prevValue,
                dataDetail: {
                    ...response.data.data,
                    stnk: getData("stnk", response.data.data.samsatSTNKResponseDTO, this.props.user, kodeCabang, processSamsatId),
                    taxSheets: getData("taxSheets", response.data.data.samsatPajakResponseDTO, this.props.user, kodeCabang, processSamsatId),
                    platNumber: getData("platNumber", response.data.data.samsatPlatKendaraanResponseDTO, this.props.user, kodeCabang, processSamsatId),
                    bpkb: getData("bpkb", response.data.data.samsatBPKBResponseDTO, this.props.user, kodeCabang, processSamsatId),
                },
            }));
        }
    }

    render() {
        return (
            <Fragment>
                <SimpleModal
                    title="Detail Proses Penerimaan SAMSAT"
                    visible={this.props.visible}
                    onClickClose={() => this.props.onClickClose()}
                    content={
                        <ModalContainer>
                            <OnSamsatHeaderInputModifying
                                {...this.props}
                                dataDetail={this.state.dataDetail}
                            />

                            <Tabs onSelect={(index) => this.handleTabChange(this.listTabValue[index])}>
                                <TabList>
                                    {this.listTabPanel.map((tab, index) => (
                                        <Tab key={index} id={`button_navigate_${tab.toLowerCase()}`}>
                                            {tab}
                                        </Tab>
                                    ))}
                                </TabList>
                                {!R.isNil(this.state.dataDetail[this.state.activeTab]) && this.listTabPanel.map((item, index) => {
                                    return (
                                        <TabPanel key={`${index}-${item}`}>
                                            <OnSamsatDetailInputModifying
                                                id={`${index}-${item}`}
                                                {...this.props}
                                                formGroup={formGroupOnSamsatAcceptance[this.state.activeTab]}
                                                initialValues={this.state.dataDetail[this.state.activeTab]}
                                                dataDetail={this.state.dataDetail}
                                                tab={this.state.activeTab}
                                                onSubmit={this.handleSubmit}
                                            />
                                        </TabPanel>
                                    );
                                })}
                            </Tabs>
                        </ModalContainer>
                    }
                />

                <SimpleLoadingOverlay active={this.state.loading}/>
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
    };
};

export default connect(mapStateToProps, null)(OnSamsatAcceptanceModifying);
